class videosGrid {
  constructor (
    items, id, completeCallback = null, autoplay = 0, itemsPerSlide = 1,
    maxItems = null, showQuote = false) {
    this.swiper = null
    this.autoplay = autoplay
    this.id = id
    this.itemsPerSlide = itemsPerSlide
    this.items = items
    this.lazyLoad = 'ondemand'
    this.maxItems = maxItems ? maxItems : this.items.length
    this.loadedItems = 0
    this.initialized = false
    this.videosLoaded = false
    this.gridItemTL = null
    this.intervalHighlight = null
    this.showQuote = showQuote
    // Carousel.
    this.videoGridContainer = document.getElementById(this.id)
    this.videoGrid = this.videoGridContainer.querySelector('.swiper-container')
    this.videoGridWrapper = this.videoGrid.querySelector('.swiper-wrapper')
    let self = this
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('video-overlay')) {
        var item = e.target
        var embed = item.querySelector('.embedded-video')
        var videoSlide = item.closest('.video-grid--item')
        
        embed.classList.add('open')
        videoSlide.classList.add('open')
        let player = new Vimeo.Player(embed.querySelector('iframe'))
        player.play()
      }
      else if (e.target.classList.contains('video-close')) {
        var item = e.target
        var embed = item.closest('.embedded-video')
        var videoSlide = embed.closest('.video-grid--item')
        
        embed.classList.remove('open')
        videoSlide.classList.remove('open')
        let player = new Vimeo.Player(embed.querySelector('iframe'))
        player.pause()
      }
    })

    // Start.
    this.calculateMaxItems()
    // this.shuffleArray()
    this.createSlides()
    this.createCarousel()

    if (completeCallback) {
      completeCallback()
    }
  }

  calculateMaxItems () {
    this.maxItems = this.maxItems > this.items.length ? this.items.length : this.maxItems
  }

  createSlides () {
    let slide = null
    for (let i = 0; i < this.maxItems; i++) {
      let item = this.items[i]
      if (i % this.itemsPerSlide === 0) {
        slide = this.createSlide()
      }
      this.createItem(slide, item, i)
    }
  }

  createSlide () {
    let slide = document.createElement('div')
    slide.classList.add('video-grid--slide')
    slide.classList.add('swiper-slide')
    this.videoGridWrapper.appendChild(slide)
    return slide
  }

  createItem (slide, itemData, index) {
    let self = this,
      videoUrl = 'https://player.vimeo.com/video/' + itemData.vimeoId,
      vimeoId = itemData.vimeoId,
      title = itemData.title,
      content = itemData.content,
      bg = itemData.background

    /**
     * Grid item.
     * @type {HTMLDivElement}
     */

    let container = document.createElement('div')
    container.classList.add('video-grid--item')
    container.classList.add('video-item')
    container.setAttribute('data-video', videoUrl)
    container.setAttribute('data-title', title)
    container.setAttribute('data-content', content)
    container.setAttribute('data-index', index)

    let videoBackground = document.createElement('div')
    videoBackground.classList.add('video-background')
    videoBackground.setAttribute('style', "background-image: url('" + bg + "')")
    container.appendChild(videoBackground)

    let item = document.createElement('div')
    item.classList.add('video-overlay')

    let video = document.createElement('div')
    video.classList.add('embedded-video')
    video.innerHTML = this.getVideoEmbedMarkup(videoUrl)
    
    let closeVideo = document.createElement('div')
    closeVideo.classList.add('video-close')
    video.appendChild(closeVideo)

    let player = new Vimeo.Player(video.querySelector('iframe'))
    player.on('ended', function (data) {
      container.classList.remove('open')
      video.classList.remove('open')
    })
    item.appendChild(video)

    let info = document.createElement('div')
    info.classList.add('video-info')
    info.innerHTML = title
    item.appendChild(info)

    let caption = document.createElement('div')
    caption.classList.add('video-caption')
    caption.innerHTML = content
    item.appendChild(caption)

    /**
     * Add to DOM.
     */

    container.appendChild(item)

    slide.appendChild(container)
  }

  getVideoEmbedMarkup(videoUrl, autoplay = 1) {
    return '<iframe src="' + videoUrl +
      '?loop=0&autopause=0&texttrack=' + appLanguage + '" width="640" height="1137" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
  }

  createCarousel () {
    let self = this
    new Swiper(this.videoGrid, {
      // loop: (self.items.length / self.itemsPerSlide) > 1,
      loop: false,
      effect: 'slide',
      slidesPerView: 1,
      centeredSlides: true,
      edgeSwipeThreshold: 60,
      speed: 250,
      longSwipes: false,
      autoplay: false,
      dots: true,
      // If we need pagination
      pagination: {
        el: self.videoGridContainer.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: self.videoGridContainer.querySelector('.swiper-button-next'),
        prevEl: self.videoGridContainer.querySelector('.swiper-button-prev'),
      },
      watchOverflow: true,
      on: {
        init: function () {
          self.swiper = this
          // introAnim()
          // quoteModuleAnim()
          // self.gridAnim()
          self.initialized = true
        },
        slideChange: function () {
          self.swiper = this
          // Stop previous preview.
          let previousIndex = self.swiper.previousIndex,
            previousSlide = self.swiper.slides[previousIndex],
            previousGridItems = previousSlide.getElementsByClassName('video-grid--item'),
            previousTotalItems = previousGridItems.length
            var embed = previousSlide.querySelector('.embedded-video')
            var videoSlide = embed.closest('.video-grid--item')
            embed.classList.remove('open')
            videoSlide.classList.remove('open')

            var iframe = embed.querySelector('iframe')
            if (iframe) {
              let player = new Vimeo.Player(iframe)
              player.pause()
            }
        },
      },
      breakpoints: {
        1023: {
          speed: 500,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          }
        },
      },
    })
  }

  removeHighlight (index) {
    let currentSlide = this.swiper.slides[index]
    if (currentSlide) {
      let gridItems = currentSlide.getElementsByClassName('video-grid--item')
      for (let i = 0; i < gridItems.length; i++) {
        gridItems[i].classList.remove('highlighted')
      }
    }
  }

  isScrolledIntoView (el, partial = true) {
    let rect = el.getBoundingClientRect()
    let elemTop = rect.top
    let elemBottom = rect.bottom
    // Partially visible elements return true:
    let isVisible = elemTop < window.innerHeight && elemBottom >= 0
    // Only completely visible elements return true:
    if (partial === false) {
      isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight)
    }
    return isVisible
  }

  highlightItem (currentSlide, index) {
    let gridItems = currentSlide.getElementsByClassName('video-grid--item'),
      totalGridItems = gridItems.length,
      highlightIndex = index + 1 // remove + 1 for random
    // For linear
    if (highlightIndex >= totalGridItems) {
      highlightIndex = 0
    }
    // For random
    /*while (highlightIndex === index) {
      highlightIndex = Math.floor(Math.random() * totalGridItems)
    }*/
    let gridItem = gridItems[highlightIndex]
    if (gridItem) {
      gridItem.classList.add('highlighted')
      let quoteContainer = document.getElementById('worker-quote--container'),
        quoteBig = gridItem.getAttribute('data-quote'),
        name = gridItem.getAttribute('data-name'),
        location = gridItem.getAttribute('data-location'),
        profession = gridItem.getAttribute('data-profession')
      if (quoteContainer) {
        quoteContainer.classList.remove('visible')
        quoteContainer.querySelector('#worker_quote').innerHTML = quoteBig
        quoteContainer.querySelector('#quote_worker_name').innerHTML = name
        quoteContainer.querySelector(
          '#quote_worker_location').innerHTML = location
        quoteContainer.querySelector(
          '#quote_worker_profession').innerHTML = profession

        setTimeout(function () {
          quoteContainer.classList.add('visible')
        }, 500)
      }
    }

    return highlightIndex
  }

  gridPause () {
    let index = this.swiper.activeIndex,
      currentSlide = this.swiper.slides[index],
      gridItems = currentSlide.getElementsByClassName('video-grid--item'),
      totalGridItems = gridItems.length
    // Play preview.
    for (let gridItemsIndex = 0; gridItemsIndex <
    totalGridItems; gridItemsIndex++) {
      let gridItem = gridItems[gridItemsIndex]
      let gridItemPreview = gridItem.querySelector('video')
      gridItemPreview.pause()
    }
  }

  gridPlay () {
    let index = this.swiper.activeIndex,
      currentSlide = this.swiper.slides[index],
      gridItems = currentSlide.getElementsByClassName('video-grid--item'),
      totalGridItems = gridItems.length
    // Play preview.
    for (let gridItemsIndex = 0; gridItemsIndex <
    totalGridItems; gridItemsIndex++) {
      let gridItem = gridItems[gridItemsIndex]
      let gridItemPreview = gridItem.querySelector('video')
      gridItemPreview.play()
    }
  }

  populateGrid () {
    let self = this,
      index = self.swiper.activeIndex,
      currentSlide = self.swiper.slides[index],
      highlightIndex = -1
  }

  shuffleArray () {
    for (let i = this.items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * i)
      const temp = this.items[i]
      this.items[i] = this.items[j]
      this.items[j] = temp
    }
  }
}

$(window).resize(checkResize);

function checkResize(){
  var pageBody = document.querySelector('body')
  if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
  ){
      // action for fullscreen enable
      console.log("fullscreen true");
      pageBody.classList.add('fullscreen-active')

  }else{
      // action for fullscreen disable
      console.log("fullscreen false");
      pageBody.classList.remove('fullscreen-active')
      $([document.documentElement, document.body]).scrollTop($("#video-grid--container").offset().top);
  }
}